module.exports = __webpack_public_path__ + "static/AverageTeam-6ff4b4493c756f92583b3d238c3a8929.jpg";